import { useState, useEffect } from 'react';

/**
 * @typedef WindowSizeHookValues
 * @property windowWidth - available music collection
 * @property windowHeight - list of creative artists
 */
/**
 *
 * @returns {WindowSizeHookValues}
 */
function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        // Add event listener and call right away
        window.addEventListener("resize", handleResize);
        handleResize();
        // Clean up
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return {
        windowWidth: windowSize.width,
        windowHeight: windowSize.height
    };
}

export default useWindowSize;
